module.exports = __webpack_public_path__ + "img/project_e9.1e07def5.png";